import { useTranslation } from 'libs/i18n'

export const useFilters = () => {
	const { t } = useTranslation()

	return [
		{
			id: 'published',
			label: t('Status'),
			placeholder: t('All'),
			options: [
				{
					value: '1',
					label: t('Published')
				},
				{
					value: '0',
					label: t('Unpublished')
				}
			]
		},
		{
			id: 'printed',
			label: t('Printed'),
			placeholder: t('All'),
			options: [
				{
					value: 'true',
					label: t('Printed')
				},
				{
					value: 'false',
					label: t('Not printed')
				}
			]
		}
	]
}
